module.exports = __webpack_public_path__ + "img/debate.8b789e80.jpg";